var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { margin, height, width } from 'styled-system';
var Card = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  position: relative;\n  border: 1px solid ", ";\n  ", ";\n  ", ";\n  ", ";\n  overflow: auto;\n"], ["\n  ",
    "\n  position: relative;\n  border: 1px solid ", ";\n  ", ";\n  ", ";\n  ", ";\n  overflow: auto;\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    border-radius: " + theme.space[1] + "px;\n    background-color: " + theme.color.white + ";\n    padding: " + theme.space[4] + "px;\n  ";
}, function (_a) {
    var theme = _a.theme;
    return theme.color.border;
}, margin, height, width);
Card.defaultProps = {
    width: 'fit-content',
};
export default Card;
var templateObject_1;
